import { Injectable } from '@angular/core';

/**
 * The console is dark only. `<html class="dark">` in index.html sets the dark
 * bk tokens for the whole document, including overlays and menus portaled to
 * <body>. `currentTheme` stays so charts, toasts and Metabase embeds that
 * read it keep working; it never changes.
 */
@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  readonly currentTheme = 'dark' as const;

  /** Clears the light/system choice earlier builds stored. */
  getTheme() {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.removeItem('theme');
      window.localStorage.removeItem('selectedTheme');
    } catch {
      // Storage can be blocked (private mode); nothing to clear.
    }
  }
}
